import { Options, createFocusTrap } from "focus-trap";

export const focusTrap = (
    target: HTMLElement,
    params: {
        enabled: boolean;
        elements?: HTMLElement[];
        options?: Options;
    }
) => {
    const elements = params.elements ? [target, ...params.elements] : [target];
    const trap = createFocusTrap(elements, params.options);

    if (params.enabled) {
        trap.activate();
    }

    function destroy() {
        trap.deactivate();
    }

    function update(newParams: { enabled: boolean; elements?: HTMLElement[] }) {
        const newElements = newParams.elements
            ? [target, ...newParams.elements]
            : [target];
        trap.updateContainerElements(newElements);

        if (newParams.enabled) {
            trap.activate();
        } else {
            trap.deactivate();
        }
    }

    return {
        update,
        destroy,
    };
};
